export default __webpack_public_path__ + "static/media/play.54711e36.svg";